export const formatCUIT = (cuit: string) =>
    `${cuit.slice(0, 2)}-${cuit.slice(2, cuit.length - 1)}-${
        cuit[cuit.length - 1]
    }`;
